import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import CSSModules from "react-css-modules";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router";
import {push, replace} from "react-router-redux";
import { reduxForm, Field } from "redux-form";
import * as actionCreators from "actions/auth/authWithOtp/authActions2";
import AuthLayout from "components/layout/auth/AuthLayout";
import RaisedButton from "components/common/material/RaisedButton";
import FormInput from "components/common/material-form/Input";
import registerUrl from "../../../utils/url/registerUrl";
import forgotPasswordUrl from "utils/url/forgotPasswordUrl";
import contactUsUrl from "utils/url/contactUsUrl";
import MobileBanner from "components/banners/MobileBanner";
import { ValidationsUtils } from "utils/validationUtils";
import styles from "./login.scss";
import {ATP_BANNER_LIMIT_KEY, CARD_APPLY_BANNER_LIMIT_KEY, TRUE} from "../../../constants/session-constants";


function validate(values, props) {
  const {
    intl: { formatMessage }
  } = props;

  let errors = {};
  const email = values.email;
  const password = values.password;
  errors.email = ValidationsUtils.validateEmail(email) ? null : formatMessage({ id: "auth.login.invalidEmail" });
  errors.password =  password ? null : formatMessage({ id: "auth.login.emptyPassword" });

  return errors;
}

@injectIntl
@connect(
  state => ({
    isAuthenticated: state.auth.isAuthenticated,
    isAuthenticating: state.auth.isAuthenticating,
    statusText: state.auth.statusText,
  }),
  dispatch => ({
    actions: bindActionCreators(actionCreators, dispatch),
    redirect: (path) => dispatch(replace(path)),
  })
)
@reduxForm({
  form: "loginForm",
  validate
})
@CSSModules(styles)
class Login2 extends React.Component {
  static propTypes = {
    intl: intlShape,
    handleSubmit: PropTypes.func,
    statusText: PropTypes.string,
    actions: PropTypes.object.isRequired,
    isAuthenticating: PropTypes.bool.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    dispatch: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    if (this.props.isAuthenticated) {
      this.props.dispatch(push("/"));
    }
    this.submit = this.submit.bind(this);
    this.state = {
      email: "",
      password: "",
      isRememberMe: false,
      loginAttempts: 0,
    };
    this.checkForError();
  }

  checkForError() {
    const message = sessionStorage.getItem("errorMessage");
    if (message) {
      sessionStorage.removeItem("errorMessage");
      this.props.actions.setStatusText(message);
    }
  }

  componentDidMount() {
    localStorage.setItem(ATP_BANNER_LIMIT_KEY,TRUE);
    localStorage.setItem(CARD_APPLY_BANNER_LIMIT_KEY,TRUE);
  }

  submit(fromValues) {
    const loginUser = this.props.actions.loginUser;
    const loginAttempts = this.state.loginAttempts+1;

    this.setState({
      loginAttempts
     }, () => {
        loginUser(fromValues.email, fromValues.password);
    });
  }

  renderBadCredentials() {
    const {
      intl: { formatMessage }
    } = this.props;
    const contactUsLink = (
      <a href={contactUsUrl()} target="_blank" >
        {formatMessage({ id: "common.link.contactUs.text" })}
      </a>
    );

    const resetAccountLink = (
      <a href={forgotPasswordUrl('reset account')}>
        {formatMessage({ id: "auth.login.fail.resetPassword" })}
      </a>
    );

    if (this.props.statusText.includes("locked")) {
      return (
        <div styleName="message">
          <div
            styleName="message"
            data-at="login-failed"
            data-at-info="account-locked" >
              <FormattedMessage
                id="auth.login.fail.locked"
              />
          </div>
          <div
            styleName="message"
            data-at="login-failed-actions"
            data-at-info="account-locked-actions" >
              <FormattedMessage
                id="auth.login.fail.lockedActions"
                values={{ contactUsLink, resetAccountLink }}
              />
          </div>
        </div>
      );
    }

    if (this.props.statusText.includes("Recaptcha")) {
      return (
          <div
            styleName="message"
            data-at="login-failed-recaptcha"
            data-at-info="account-error-recaptcha" >
              <FormattedMessage
                id="auth.login.fail.recaptchaError"
              />
          </div>
      );
    }

    return (
      <div
        styleName="badCredentialsMessage"
        data-at="login-failed"
        data-at-info="bad-credentials"
      >
        <FormattedMessage
          id="auth.login.fail.badCredentials2"
          values={{ contactUsLink }}
        />
      </div>
    );
  }

  renderSignUpSection() {
    const signUpLink = (
      <Link data-at="createAccountLink" to={registerUrl()}>
        <FormattedMessage id="auth.login.signUpLinkText" />
      </Link>
    );

    return (
      <div styleName="signUpSection">
        <FormattedMessage
          id="auth.login.donHaveAnAccount"
          values={{ signUpLink }}
        />
      </div>
    );
  }

  renderForgotPasswordSection() {
    const clickHere = (
      <Link data-at="forgotPasswordLink" to={forgotPasswordUrl()}>
        <FormattedMessage id="forgotPassword.fromLogin.clickHere" />
      </Link>
    );

    return (
      <div styleName="signUpSection">
        <FormattedMessage
          id="forgotPassword.fromLogin.text"
          values={{ clickHere }}
        />
      </div>
    );
  }

  renderDownloadAppBanner() {
    return (
      <MobileBanner
        bannerStyle="dark"
        bannerMessage="app.banner.message"
        downloadBtnLabel="app.banner.btnLabel"/>
    );
  }

  // toggleRememberMeChecked(isChecked) {
  //   this.setState((state) => {
  //     return {
  //       ...state,
  //       isRememberMe: isChecked
  //     };
  //   });
  // }

  render() {
    const {
      handleSubmit,
      intl: { formatMessage }
    } = this.props;
    return (
      <div>
        {this.renderDownloadAppBanner()}
        <AuthLayout>
          <div className="title">Sign In</div>
          <div className="subtitle">Please enter your details below to sign in.</div>
          {this.props.statusText
            ? this.renderBadCredentials(this.props.statusText)
            : ""}
          <form
            role="form"
            data-at="login"
            onSubmit={handleSubmit(this.submit)}
            noValidate={true}
          >
            <Field
              name="email"
              data-at="login-email"
              component={FormInput}
              hint={formatMessage({ id: "auth.login.email" })}
              label={formatMessage({ id: "auth.login.email" })}
              fullWidth={true}
            />
            <Field
              type="password"
              name="password"
              data-at="login-password"
              component={FormInput}
              hint={formatMessage({ id: "auth.login.password" })}
              label={formatMessage({ id: "auth.login.password" })}
              fullWidth={true}
            />
            {/*<div styleName="rememberMe">*/}
            {/*  <input type="checkbox"*/}
            {/*         onClick={(event) => this.toggleRememberMeChecked(event.target.checked)}*/}
            {/*         value={this.state.isRememberMe}/>*/}
            {/*  <span>Remember this device</span>*/}
            {/*</div>*/}
            <RaisedButton
              label="Login"
              primary={true}
              fullWidth={true}
              type="submit"
              disabled={this.props.isAuthenticating || this.props.invalid}
              onClick={this.login}
              data-at="login-submit"
              style={{marginTop: 8}}
              icon="lock"
            />
          </form>
          <br />
          {this.renderSignUpSection()}
          {this.renderForgotPasswordSection()}
          <div styleName="privacyPolicy">
            <a
              href="https://sunbit.com/consumer-privacy-policy.html"
              target="_blank"
            >
              Privacy Policy
            </a>
          </div>
        </AuthLayout>
      </div>
    );
  }
}

export default Login2;



// WEBPACK FOOTER //
// ./src/containers/auth/login/Login2.js